import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/storage";
import { getAuth } from "firebase/auth";

import { logError } from "@/revamp/utils";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

//init firebase (guard against src/firebase/config.js already having initialized the default app)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const AuthService = firebase.auth();
const DatabaseService = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;
const increment = firebase.firestore.FieldValue.increment(1);

const FIREBASE_FUNCTION_HEADERS = {
  "x-api-key": process.env.VUE_APP_FRIENDLIER_API_KEY,
  ContentType: "application/json",
};

export {
  AuthService,
  DatabaseService,
  timestamp,
  increment,
  FIREBASE_FUNCTION_HEADERS,
};
